import Typography from '@mui/material/Typography';
import CashFlowData from './PaymentsList';

const OutflowPayments =() => {
    return(
      <>
       <Typography>
         <CashFlowData accountType={'Outflow'} type={'account-payable'} />
       </Typography>
       </>
       );
}; 
export default OutflowPayments;